import styled, { css } from 'styled-components';

export const ComboListContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.surface.base};
`;

export const ComboListTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  font-family: 'Elza', sans-serif;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ListOfCombos = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  list-style: none;

  @media (min-width: 1200px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const ComboListItem = styled.li<{ $selected: boolean }>`
  width: 100%;

  @media (min-width: 1200px) {
    width: calc(50% - 8px);
  }

  & input[type="radio"] {
    appearance: none;
    width: 16px;
    height: 16px;
    -webkit-appearance: none; 
    border: 1px solid ${({ theme }) => theme.colors.button.text.disabled};
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    outline: none;
  }

  & input[type="radio"]:checked {
    border: 1px solid ${({ theme }) => theme.colors.accent.primary};
  }

  & input[type="radio"]:checked::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.accent.primary};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  & label {
    font-family: 'Elza', sans-serif;
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.surface.high};
    transition: background-color 0.2s;
    border-radius: 8px;
    border: 1px solid ${({ theme, $selected }) => $selected ? (
    theme.colors.accent.primary
  ) : theme.colors.border};

    &:hover {
      background-color: ${({ theme }) => theme.colors.surface.low};
    }

    & input[type="radio"]:checked ~ label {
      border-color: ${({ theme }) => theme.colors.accent.primary};
    }
  }
`;

export const ComboListBtnContainer = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  padding: 24px;
  padding-top: 16px;
  justify-content: space-between;
  flex-direction: column-reverse;
  gap: 10px;
  
  @media (min-width: 1200px) {
    flex-direction: row;
    padding: 12px 24px;
  }
`;

export const ComboListButton = styled.button<{ $isBackBtn : boolean }>`
  padding: 8px 24px;
  width: 100%;
  border-radius: 100px;
  color: ${({ theme }) => theme.colors.button.text.primary};
  font-weight: 700;
  font-size: 14px;
  font-family: 'Elza', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $isBackBtn }) => $isBackBtn && css`
    background-color: ${({ theme }) => theme.colors.button.surface.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
    transition: background-color 0.2s;
    border: 1px solid ${({ theme }) => theme.colors.border};

    &:hover {
      background-color: ${({ theme }) => theme.colors.button.hover.secondary};
    }
  `}


  @media (min-width: 1200px) {
    width: fit-content;
  }
`;
